import React from 'react'
import '../../css/notfound.css'
import { Link } from 'react-router-dom'
const NotFound = () => {
    return (
        <div className='container-404'>
            <p>You might be lost or the link is broken.</p>
            <br/>
            <Link to='/netflix-replica' className='return-home-btn'>Click To Return Home</Link>
        </div>
    )
}

export default NotFound
